import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/theydo.webp';
import screenshot_target from '../../../images/letterfunnel/charlesbeaumont.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Charles Beaumont"
      firstname="Charles"
      companyname="TheyDo"
      competition="Smaply en UXPressia"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/charlesbeaumont.js